import { Suspense } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';
import { useGetSessionQuery } from '../api/apiSlice';
import { getSelectedAccount } from '../redux/selectedAccountSlice';

const EnergyXplorerRoute = () => {
  const { data: session, isLoading } = useGetSessionQuery();
  const isAdmin = session?.claims?.['accounts.superuser'] === 'True' || false;
  const selectedAccount = useSelector(getSelectedAccount);
  //const selectedAccountValid = validateSelectedAccount(session, selectedAccount.AccountId)
  const hasService = selectedAccount?.Services?.some(
    (s) => s.Name === 'EnergyXplorer',
  );
  const email_verified = session?.claims?.['email_verified'];
  if (!selectedAccount?.AccountId) return;
  return hasService || isAdmin ? ( // && email_verified
    <Suspense>
      <Outlet />
    </Suspense>
  ) : (
    <Navigate to="/" replace />
  );
};

export default EnergyXplorerRoute;
